import { render, staticRenderFns } from "./ImsProfitLossDashboard.vue?vue&type=template&id=97959248&"
import script from "./ImsProfitLossDashboard.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ImsProfitLossDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports